"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhonenumberProviderEnum = void 0;
var PhonenumberProviderEnum;
(function (PhonenumberProviderEnum) {
    PhonenumberProviderEnum["CONNECTEL"] = "CONNECTEL";
    PhonenumberProviderEnum["VOXBONE"] = "VOXBONE";
})(PhonenumberProviderEnum = exports.PhonenumberProviderEnum || (exports.PhonenumberProviderEnum = {}));
